import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValueSet, LocalService, PageKey, ProductEntryType, Status, TriggeredEvent, Wrappers15, Wrappers20 } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { SellerManagementService } from 'src/service/seller-management.service';
import { GetPriceIncludeTax } from 'src/app/supporting/conversion';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyValueId } from 'src/app/supporting/receiptPrint';

@Component({
  selector: 'app-base-amount-conversion',
  templateUrl: './base-amount-conversion.component.html',
  styleUrl: './base-amount-conversion.component.scss'
})
export class BaseAmountConversionComponent {
  lstSectionConfigKeys: string[] = ["table", "product_config"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; maxBodyHeight = 0;

  wrappers: Wrappers20; businessId: string = ''; selectedProductEntryType: string = ProductEntryType.Billing.toString(); selectedProductCategory: string = ''; expectedBusinessTypes: KeyValueSet[]; businessType: string = ''; isSelectedAll = false;
  selectedCount = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private sellerManagementService: SellerManagementService, private modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.BaseAmountConvertion, this.businessId);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onGetExpectedBusiness();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    if (this.expectedBusinessTypes && this.expectedBusinessTypes.length > 0) {
      if (!(this.businessType && this.businessType.length > 0)) {
        this.businessType = this.expectedBusinessTypes[0].key;
      }
      this.onLoad();
    }
  }

  isLoading = false;
  onLoad() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.productManagementService.getProducts(this.businessId, false, this.selectedProductCategory, !this.wrappers ? null : this.wrappers.paging, '', parseInt(this.selectedProductEntryType), true, parseInt(this.businessType)).subscribe(result => {
        this.wrappers = result;
        this.onSetPrice();
        this.onSelect();
        this.isLoading = false;
      });
    }
  }

  onSetPrice() {
    this.wrappers.items.forEach(product => {
      product.isSelected = false;
      const businessTaxes = this.wrappers.businessTaxesFull.find(x => x.key == product.v15);
      const currentPrice = parseFloat((product.productTax?.content?.v4 ?? '0').toString());
      const productTaxPrice = GetPriceIncludeTax(currentPrice, businessTaxes?.values ?? [], product.productTax?.requiredTax ?? []);
      product.v11 = currentPrice.toFixed(2);
      product.v12 = Math.round(productTaxPrice).toFixed(2);
    });
  }

  onGetExpectedBusiness() {
    this.expectedBusinessTypes = [];
    this.sellerManagementService.getExpectedBusinessTypes(this.localService.getLoginAsCountryCode() , this.businessId).subscribe(result => {
      result.forEach(res => {
        this.expectedBusinessTypes.push({
          key: res,
          value: this.localService.getText(this.localService.businessTypes, res)
        } as KeyValueSet);
      });
      this.onInitiate();
    });
  }

  onCheckAll() {
    this.wrappers.items.forEach(x => x.isSelected = this.isSelectedAll);
    this.selectedCount = this.wrappers.items.filter(x => x.isSelected).length;
  }

  onSelect() {
    this.selectedCount = this.wrappers.items.filter(x => x.isSelected).length;
    this.isSelectedAll = this.wrappers.items.length == this.selectedCount;
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(MessageComponent);
        modalRef.componentInstance.IsConfirmationType = true;
        modalRef.componentInstance.message = this.localService.languageContent.product_config.convert_confirmation;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onConvert();
          }
        });
      } break;
    }
  }

  onConvert() {
    const items: KeyValueId[] = this.wrappers.items.filter(x => x.isSelected).map(function (product) {
      return {
        key: product.key,
        value: product.v12
      } as KeyValueId;
    });

    this.productManagementService.updateBaseAmount(items, parseInt(this.businessType)).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
